import { tags } from './tags';

function endpoints(builder) {
  return {
    getParticipation: builder.query({
      query: (participationId) => `tefaf/exhibitorportal/participation/get/${participationId}`,
      providesTags: tags,
    }),
    editContacts: builder.mutation({
      invalidatesTags: tags,
      query: (values) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'tefaf/exhibitorportal/participation/save');
        body.append('participationId', values.participationId);
        if (values.billingAddressSalesforceId) {
          body.append('fields[billingAddressSalesforceId]', values.billingAddressSalesforceId);
        }
        if (values.mailingAddressSalesforceId) {
          body.append('fields[mailingAddressSalesforceId]', values.mailingAddressSalesforceId);
        }
        if (values.primaryContactSalesforceId) {
          body.append('fields[primaryContactSalesforceId]', values.primaryContactSalesforceId);
        }
        if (values.billingContactSalesforceId) {
          body.append('fields[billingContactSalesforceId]', values.billingContactSalesforceId);
        }
        if (values.galleryOwner1ContactSalesforceId) {
          body.append('fields[galleryOwner1ContactSalesforceId]', values.galleryOwner1ContactSalesforceId);
        }
        if (values.galleryOwner2ContactSalesforceId) {
          body.append('fields[galleryOwner2ContactSalesforceId]', values.galleryOwner2ContactSalesforceId);
        }
        if (values.prAndMarketingContactSalesforceId) {
          body.append('fields[prAndMarketingContactSalesforceId]', values.prAndMarketingContactSalesforceId);
        }
        if (values.socialMediaContactSalesforceId) {
          body.append('fields[socialMediaContactSalesforceId]', values.socialMediaContactSalesforceId);
        }

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
    }),
  };
}

export { endpoints };
